export const GoogleMapApiConfig = 'AIzaSyC6nR96My5X2m_DDNgQHXwbnhL5ir7JZps';